module.exports = __webpack_public_path__ + "img/certificate.48e14d0c.png";